.icon {
  display: block;
  width: var(--life-icon-size);
  height: var(--life-icon-size);
  flex: none;
  object-fit: contain;
}
